import { useEffect } from "react";

export const useBannerImage = (config: { banner?: string }) => {
    useEffect(() => {
        if (config.banner) {
            let timeout: ReturnType<typeof setTimeout> | null = null;
            const banner =
                document.querySelector<HTMLImageElement>(".banner-bg");
            if (!banner) return;
            banner.style.setProperty(
                "--banner-after-image",
                banner.style.backgroundImage,
            );
            setTimeout(() => {
                banner.style.backgroundImage = `url(${config.banner})`;
                banner.style.setProperty("--banner-after-opacity", "0");

                timeout = setTimeout(() => {
                    banner.style.setProperty("--banner-after-image", "");
                    banner.style.setProperty("--banner-after-opacity", "1");
                }, 200);
            });

            return () => {
                if (timeout) clearTimeout(timeout);
                banner.style.setProperty("--banner-after-image", "");
                banner.style.setProperty("--banner-after-opacity", "1");
            };
        }
    }, [config.banner]);
};
